import React, { useState } from 'react'
import './style.scss'
import { MyArrowButtom } from '../IconSvg'

const MultiSelectionDrp = ({ list = [], itemComponent, itemClickHandler, selectedList, selectedItemsComponent, bottomTool, isMultiSelect = true }) => {
    const [isOpen, setIsOpen] = useState(false)
    const wrapperRef = React.useRef(null)
    useOutsideAlerter(wrapperRef, setIsOpen)
    return (
        <div className='multi-selection-drp-context' ref={wrapperRef}>
            <div className='selected-context' onClick={() => setIsOpen(!isOpen)}>{selectedItemsComponent(selectedList, itemClickHandler)}
                <span className='arrow-container'>
                    <MyArrowButtom />
                </span>

            </div>
            <div className={isOpen ? 'opened list-container' : 'list-container'}>
                {list.map((item, idx) =>
                    <div key={idx} onClick={() => {
                        if (!isMultiSelect) {
                            setIsOpen(false);
                        }
                        itemClickHandler(item, idx);
                    }} >
                        {itemComponent({ item, idx, itemClickHandler, selectedList })}
                    </div>
                )}
                {bottomTool && <section>{bottomTool()}</section>}
            </div>

        </div>
    )
}

export default MultiSelectionDrp



function useOutsideAlerter(ref, setDisplay) {
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setDisplay(false)
            }
        }
        document.body.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.body.removeEventListener('mousedown', handleClickOutside)

        }
    }, [ref])
}
